import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const HOST_URL = process.env.REACT_APP_HOST_URL || "http://localhost:8000";

const LoginGuest: React.FC = () => {
  const navigate = useNavigate();
  const [uid, setUid] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const res = await fetch(`${HOST_URL}/api/v1/auth/login/guest`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid, password }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || "로그인에 실패했습니다.");
        return;
      }

      const { access_token } = await res.json();
      sessionStorage.setItem("avatye:ops:admin:accessToken", access_token);
      navigate("/pointhome", { replace: true });
    } catch {
      setError("서버에 연결할 수 없습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-box">
          <div className="login-header">
            <img src="/logo192.png" alt="Logo" className="login-logo" />
            <span className="login-brand">애널리틱스</span>
          </div>

          <h1 className="login-title">게스트 로그인</h1>
          <p className="login-subtitle">
            발급받은 아이디와 비밀번호로
            <br />
            대시보드에 접속하세요
          </p>

          <form onSubmit={handleLogin}>
            <input
              className="email-input"
              type="text"
              placeholder="아이디"
              value={uid}
              onChange={(e) => setUid(e.target.value)}
              autoComplete="username"
              required
            />
            <input
              className="email-input"
              type="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              className="ms-login-button"
              type="submit"
              disabled={loading}
            >
              <span>{loading ? "로그인 중..." : "로그인"}</span>
            </button>
          </form>

          {error && <p className="error-message">{error}</p>}

          <p className="login-footer">
            Avatye 임직원 전용 서비스입니다.
          </p>
        </div>
      </div>

      <div className="login-right" />
    </div>
  );
};

export default LoginGuest;
